import { render, staticRenderFns } from "./RoundModal.vue?vue&type=template&id=6821ffac&"
import script from "./RoundModal.vue?vue&type=script&lang=js&"
export * from "./RoundModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports